import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React from 'react';

import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import useCarriersPreparing from '#app/View/InventoryManagement/PreparerManager/hooks/useCarriersPreparing';
import { CarrierCode, CarrierTranslation } from '#app/typings/carrier';

const CarrierList: React.FC = () => {
  const classes = useStyles();
  const { carriers } = useCarriersPreparing();

  const CarrierImage = [
    { code: CarrierCode.MONDIAL_RELAY, image: 'carrier_mondial_relay.png' },
    { code: CarrierCode.MONDIAL_RELAY_TLN, image: 'carrier_mondial_relay.png' },
    { code: CarrierCode.MONDIAL_RELAY_EIYOLAB, image: 'carrier_mondial_relay.png' },
    { code: CarrierCode.DACHSER, image: 'carrier_dachser.png' },
    { code: CarrierCode.DPD_HOME, image: 'carrier_dpd.png' },
    { code: CarrierCode.DPD_PICKUP, image: 'carrier_dpd.png' },
  ];

  return (
    <Grid container spacing={1} className={classes.container}>
      {CarrierImage.map(({ code, image }) => (
        <Grid key={code} size={4}>
          <ShadowBoxComponent>
            <img className={classes.image} src={`/image/${image}`} alt="" />
            <div className={classes.label}>{CarrierTranslation[code]}</div>
            <b>{carriers.find((carrier) => carrier.code === code)?.count ?? 0}</b>
          </ShadowBoxComponent>
        </Grid>
      ))}
    </Grid>
  );
};

const useStyles = makeStyles({
  container: {
    marginTop: 20,
    marginBottom: 20,
    textAlign: 'center',
  },
  label: {
    marginTop: 5,
    marginBottom: 5,
  },
  image: {
    height: 30,
  },
});

export default CarrierList;
